import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {PostDO} from '../data-objects/PostDO';

@Component({
  selector: 'app-base-thumbnail',
  templateUrl: './base-thumbnail.component.html',
  styleUrls: ['./base-thumbnail.component.scss']
})
export class BaseThumbnailComponent implements OnInit, OnChanges {
  @Input() post: PostDO;
  @Input() altText: string;
  maxTags: string[];
  MAX_TAGS_COUNT = 4;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.video) {
      this.maxTags = this.post.tags.splice(0, this.MAX_TAGS_COUNT);
    }
  }

  getImageUrl(post): string {
    return post.featuredImageSizes ? post.featuredImageSizes.medium : null;
  }

  get postLink(): string[] {
    return [this.post.slug];
  }
}
